<section>
    <img width="100%" src="/assets/images/micrositio/homepage/HOME_041.jpg">
    <br>
    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
</section>
<div class="container">
    <div class="row marg">
        <div class="col-sm-12">
            <div class="row">
                <div class="col-sm-7">
                    <p class="font-20 text-grey">
                        RECORRIDOS
                    </p>
                    <p class="fontMS700 colorPrincipal font-40" style="line-height: 2.5rem;">
                        CREADORES
                        <br>
                    </p>
                </div>
                <div class="col-sm-5">                  
                    <div id="sharePic">
                        <a (click)="test.toggle()" mdbWavesEffect>
                            <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
                        </a>
                        <div mdbCollapse #test="bs-collapse">
                            <div class="divShared">
                                &nbsp;
                                &nbsp;
                                <a target="_blank"
                                    href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fhome/generica1">
                                    <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                                </a>&nbsp;
                                <a target="_blank"
                                    href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fhome/generica1">
                                    <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                                </a>&nbsp;
                                <a target="_blank"
                                    href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fhome/generica1">
                                    <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-7">
                    <p class="font-20">
                        <br>
                        <span class="fontMS500 font-22">
                            LA OBRA, EL PENSAMIENTO Y LA CREACIÓN DE ARTISTAS, INTELECTUALES, ESCRITORAS Y ESCRITORES
                            HAN APORTADO AL ENTENDIMIENTO DE NUESTRA HISTORIA, SOCIEDAD Y CULTURA.
                            <br><br>
                        </span>
                        Libros, manuscritos, cartas, fotografías, entre otros documentos, nos aproximan a sus distintas
                        facetas, dando cuenta de la trayectoria intelectual y artística de cada uno de estos creadores y
                        creadoras.
                        En los diferentes temas de este recorrido podrás conocer las colecciones de Ricardo Palma, José
                        María Arguedas, José María Eguren, Magda Portal, entre otras.
                        <br><br>
                    </p>
                </div>
                <div class="col-sm-1">
                </div>
                <div class="col-sm-4">
                    <p class="fontMS500 font-22">
                        <br> OTROS RECORRIDOS <br>
                        <span class="font-20 text-grey">
                            <u>
                                <a style="color: inherit;" (click)="miradasArta()">Miradas desde el arte</a><br>
                                <a style="color: inherit;" (click)="comunidadesImg()">Comunidades imaginadas
                                </a> <br>
                                <a style="color: inherit;" (click)="transiciones()">Transiciones y transformaciones
                                    <br>sociales</a> <br>
                            </u>
                        </span>
                    </p>
                </div>
            </div>
            <p class="fontMS500 font-30">
                TEMAS
            </p>
            <div class="row">
                <div class="col-sm-8">
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="DoraMayer()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_026f.jpg">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="DoraMayer()">
                                <p class="fontMS700 font-24">
                                    DORA MAYER: EL SOL QUE DISIPA LAS NUBES
                                </p>
                            </a>
                        </div>

                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="ManuelGP()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_026g.jpg">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="ManuelGP()">
                                <p class="fontMS700 font-24">
                                    MANUEL GONZÁLEZ PRADA: APUNTES PARA LA HISTORIA
                                </p>
                            </a>
                        </div>

                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="RicardoPalma()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_026h.jpg">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="RicardoPalma()">
                                <p class="fontMS700 font-24">
                                    RICARDO PALMA: GUARDIÁN DEL PATRIMONIO EN EL CAMBIO DE SIGLO
                                </p>
                            </a>
                        </div>

                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="JorgeBasadre()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_026i.jpg">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="JorgeBasadre()">
                                <p class="fontMS700 font-24">
                                    JORGE BASADRE Y LA VOCACIÓN BIBLIOTECARIA EN EL PERÚ
                                </p>
                            </a>
                        </div>

                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="Pensadoras()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_026a.jpg">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="Pensadoras()">
                                <p class="fontMS700 font-24">
                                    PENSADORAS
                                    PERUANAS
                                    DEL SIGLO XIX
                                </p>
                            </a>
                        </div>

                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="Clorinda()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_026b.jpg">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="Clorinda()">
                                <p class="fontMS700 font-24">
                                    CLORINDA MATTO
                                    DE TURNER

                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="JoseEguren()">
                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_026c.jpg">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="JoseEguren()">
                                <p class="fontMS700 font-24">
                                    EL ARTE DEL POETA
                                    JOSÉ MARÍA EGUREN

                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="MagdaPortal()">

                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_026d.jpg">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="MagdaPortal()">

                                <p class="fontMS700 font-24">
                                    MAGDA PORTAL

                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="JoseMariaArguedas()">

                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_026e.jpg">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="JoseMariaArguedas()">

                                <p class="fontMS700 font-24">
                                    JOSÉ MARÍA
                                    ARGUEDAS
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="Alvarado()">

                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_046a.png">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="Alvarado()">

                                <p class="fontMS700 font-24">
                                    MARÍA JESÚS ALVARADO
                                    RIVERA (1878 – 1971)
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="Garreaud()">

                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_055a.png">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="Garreaud()">

                                <p class="fontMS700 font-24">
                                    FERNANDO GARREAUD Y EL
                                    ÁLBUM REPÚBLICA PERUANA 1900:
                                    LA PERSISTENCIA DE LA MEMORIA
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="Bernardo()">

                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_037a.png">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="Bernardo()">

                                <p class="fontMS700 font-24">
                                    JOSÉ BERNARDO ALZEDO:
                                    FILOSOFÍA DE LA MÚSICA
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="CesarVallejo()">

                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_038a.png">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="CesarVallejo()">

                                <p class="fontMS700 font-24">
                                    CÉSAR VALLEJO:
                                    “Y SI DESPUÉS DE TANTAS PALABRAS,
                                    NO SOBREVIVE LA PALABRA”
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="MariaWiesse()">

                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_058a.png">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="MariaWiesse()">

                                <p class="fontMS700 font-24">
                                    MARÍA WIESSE:
                                    “LETRA Y MÚSICA”
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="AngelicaPalma()">

                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_059a.png">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="AngelicaPalma()">

                                <p class="fontMS700 font-24">
                                    (RE)DESCUBRIENDO A ANGÉLICA PALMA:
                                    “UNA VOZ PROPIA EN LA HISTORIA”
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                    <div class="row">
                        <div class="col-sm-3">
                            <a (click)="NicomedesSantaCruz()">

                                <img width="100%" src="/assets/images/micrositio/homepage/HOME_060a.png">
                            </a>
                        </div>
                        <div class="col-sm-9">
                            <a (click)="NicomedesSantaCruz()">

                                <p class="fontMS700 font-24">
                                    NICOMEDES SANTA CRUZ:
                                    VOZ Y MEMORIA DEL PERÚ AFRODESCENDIENTE
                                </p>
                            </a>
                        </div>
                    </div>
                    <img width="100%" src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA2.jpg">
                </div>
                <div class="col-sm-4">
                </div>
            </div>
        </div>
    </div>
</div>